/** Agent activity trend: one handling agent's volume / TEU / rebook swing. */
import type { AgentActivityTrendPayload } from "@/types/feed";

import { agentBookingsHref } from "../../feedLinks";
import { formatDeltaPct, formatNum } from "../formatInsight";
import { explainerFor } from "../insightCopy";
import { CtaLink, InsightShell, MetricGrid, type MetricItem } from "../primitives";

export function AgentActivityTrendView({
  payload,
}: {
  payload: AgentActivityTrendPayload;
}) {
  const m = payload.metrics;
  const metricItems: MetricItem[] = m
    ? [
        { label: "Bookings", value: String(m.current_count) },
        { label: "Prior period", value: String(m.prior_count) },
        { label: "Change", value: formatDeltaPct(m.volume_change_pct).text },
        { label: "TEU", value: `${formatNum(m.current_teu)} TEU` },
        { label: "Rebooks", value: String(m.current_rebooks) },
        { label: "Prior rebooks", value: String(m.prior_rebooks) },
      ]
    : [];

  return (
    <InsightShell explainer={explainerFor(payload as unknown as Record<string, unknown>)}>
      {metricItems.length > 0 && <MetricGrid items={metricItems} />}
      {payload.agent && (
        <CtaLink to={agentBookingsHref(payload.agent)}>View agent bookings</CtaLink>
      )}
    </InsightShell>
  );
}
